import React, { useState } from 'react';
import { Dialog, DialogContent, DialogHeader, DialogTitle } from '@/components/ui/dialog';
import { Input } from '@/components/ui/input';
import { Button } from '@/components/ui/button';
import { useUser } from '@/context/UserContext';
import { toast } from 'sonner';
import { Rocket, Sparkles } from 'lucide-react';

const EnrollModal = ({ open, onClose }) => {
  const { createUser } = useUser();
  const [username, setUsername] = useState('');
  const [loading, setLoading] = useState(false);

  const handleEnroll = async (e) => {
    e.preventDefault();
    if (!username.trim()) {
      toast.error('Please enter a username');
      return;
    }
    
    setLoading(true);
    try {
      await createUser(username.trim());
      toast.success('Welcome to Pump University! 🎓');
      onClose();
    } catch (error) {
      toast.error('Failed to enroll. Try again.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <Dialog open={open} onOpenChange={onClose}>
      <DialogContent className="bg-pump-card border border-white/10 max-w-md" data-testid="enroll-modal">
        <DialogHeader>
          <DialogTitle className="flex items-center gap-3 font-unbounded text-2xl text-white">
            <div className="w-12 h-12 rounded-xl bg-pump-green flex items-center justify-center shadow-neon">
              <Rocket className="text-black" size={24} />
            </div>
            Enroll Now
          </DialogTitle>
        </DialogHeader>
        
        <div className="space-y-6 pt-4">
          <div className="text-center space-y-2">
            <p className="text-zinc-400 font-jakarta">
              Join the most <span className="text-pump-green">degen</span> university in crypto.
            </p>
            <div className="flex items-center justify-center gap-2 text-sm text-zinc-500">
              <Sparkles size={14} className="text-degen-purple" />
              <span>Bachelor of Pumpology awaits</span>
              <Sparkles size={14} className="text-degen-purple" />
            </div>
          </div>

          <form onSubmit={handleEnroll} className="space-y-4">
            <div className="space-y-2">
              <label className="text-sm font-medium text-zinc-400">Choose your degen name</label>
              <Input
                value={username}
                onChange={(e) => setUsername(e.target.value)}
                placeholder="e.g. PumpMaster3000"
                className="bg-pump-surface border-white/10 text-white placeholder:text-zinc-600 focus:border-pump-green focus:ring-pump-green/20"
                data-testid="username-input"
              />
            </div>

            <Button
              type="submit"
              disabled={loading}
              data-testid="submit-enroll-btn"
              className="w-full bg-pump-green text-black font-bold uppercase tracking-wider hover:shadow-neon-strong transition-all py-6"
            >
              {loading ? 'Enrolling...' : 'Start Learning'}
            </Button>
          </form>

          <p className="text-xs text-zinc-600 text-center">
            By enrolling, you agree to embrace the trenches
          </p>
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default EnrollModal;
